import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

const LegalNotice = () => {
  const { lang } = useLanguage();

  const content = {
    es: {
      title: "Aviso Legal",
      sections: [
        {
          title: "Información Legal y de Contacto",
          text: "Responsable del contenido:\nGisselle Mendez\nNemesi Valls 44\n08210 Barbera del Valles\nEspaña"
        },
        {
          title: "Contacto",
          text: "Para consultas comerciales e información de contacto, por favor envíanos un email a:\n\ncontact@gissellemendez.com"
        },
        {
          title: "Descargo de Responsabilidad",
          text: "Responsabilidad por el Contenido:\nLos contenidos de nuestras páginas han sido creados con el máximo cuidado. Sin embargo, no podemos garantizar la exactitud, integridad o actualidad de los contenidos. Según las disposiciones legales, somos responsables de nuestro propio contenido en estas páginas web.\n\nResponsabilidad por Enlaces:\nNuestra oferta contiene enlaces a sitios web de terceros externos. No tenemos influencia sobre los contenidos de esos sitios web, por lo tanto no podemos garantizar esos contenidos. Los proveedores o administradores de sitios web enlazados son siempre responsables de sus propios contenidos."
        },
        {
          title: "Derechos de Autor",
          text: "Los contenidos y compilaciones publicados en estos sitios web por los proveedores están sujetos a las leyes de derechos de autor españolas. La reproducción, edición, distribución así como el uso de cualquier tipo fuera del alcance de la ley de derechos de autor requiere un permiso escrito del autor u originador. Las descargas y copias de estos sitios web están permitidas solo para uso privado."
        },
        {
          title: "Divulgación de Afiliados",
          text: "Este sitio web contiene enlaces de afiliados. Ganamos con las compras que califican. Esto significa que si haces clic en uno de nuestros enlaces y realizas una compra, podemos recibir una pequeña comisión sin costo adicional para ti."
        },
        {
          title: "Protección de Datos",
          text: "Para información sobre cómo recopilamos, usamos y protegemos tus datos personales, por favor consulta nuestra Política de Privacidad."
        }
      ]
    },
    en: {
      title: "Legal Notice",
      sections: [
        {
          title: "Legal and Contact Information",
          text: "Content Manager:\nGisselle Mendez\nNemesi Valls 44\n08210 Barbera del Valles\nSpain"
        },
        {
          title: "Contact",
          text: "For business inquiries and contact information, please send us an email at:\n\ncontact@gissellemendez.com"
        },
        {
          title: "Disclaimer",
          text: "Responsibility for Content:\nThe contents of our pages have been created with the utmost care. However, we cannot guarantee the accuracy, completeness, or timeliness of the contents. According to legal provisions, we are responsible for our own content on these web pages.\n\nResponsibility for Links:\nOur offer contains links to external third-party websites. We have no influence over the contents of those websites, therefore we cannot guarantee those contents. The providers or administrators of linked websites are always responsible for their own contents."
        },
        {
          title: "Copyright",
          text: "The contents and compilations published on these websites by the providers are subject to Spanish copyright laws. Reproduction, editing, distribution, as well as any type of use outside the scope of copyright law, requires written permission from the author or originator. Downloads and copies of these websites are permitted only for private use."
        },
        {
          title: "Affiliate Disclosure",
          text: "This website contains affiliate links. We earn from qualifying purchases. This means that if you click on one of our links and make a purchase, we may receive a small commission at no additional cost to you."
        },
        {
          title: "Data Protection",
          text: "For information on how we collect, use, and protect your personal data, please refer to our Privacy Policy."
        }
      ]
    }
  };

  const currentContent = content[lang] || content.es;

  return (
    <div className="min-h-screen pt-32 pb-20 px-6 bg-gallery-bg">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-3xl mx-auto"
      >
        <h1 className="text-4xl md:text-5xl font-serif mb-12 text-center">{currentContent.title}</h1>
        <div className="space-y-12">
          {currentContent.sections.map((section, index) => (
            <section key={index} className="space-y-4">
              <h2 className="text-xl font-serif text-gallery-text">{section.title}</h2>
              <div className="text-gallery-muted leading-relaxed whitespace-pre-line font-light">
                {section.text}
              </div>
            </section>
          ))}
        </div>
        
        <div className="mt-20 pt-8 border-t border-gallery-border text-center">
          <p className="text-xs uppercase tracking-widest text-gallery-muted">
            Last updated: January 2026
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default LegalNotice;